import config from "../config/config";
import axios from "axios";
import { getToken } from "../common";

const buildHeaders = () => ({
  "Content-type": "application/json; charset=UTF-8",
  Authorization: getToken(),
});

export const fetchActivityLogFiltersAPI = async () => {
  return axios.get(`${config.api.base_url}activity-logs/dashboard/filters`, {
    headers: buildHeaders(),
  });
};

export const fetchImpersonationLogsAPI = async (params) => {
  return axios.get(
    `${config.api.base_url}activity-logs/dashboard/impersonation`,
    {
      params,
      headers: buildHeaders(),
    }
  );
};
